<template>
  <v-navigation-drawer
    app
    :value="visible"
    width="330"
    :mini-variant="true"
    expand-on-hover
    style="margin: 1px"
    @input="$emit('update:visible', $event)"
  >
    <template v-if="store.authorised" #prepend>
      <v-list nav>
        <v-list-group no-action>
          <template #activator>
            <!-- <v-list-item-title>Л/счёт</v-list-item-title> -->
            <v-list-item-icon>
              <v-icon>mdi-account-circle</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>
                Л/счёт (
                <span v-if="balance" style="color: green">
                  {{ balance }} руб.
                </span>
                )
                <v-btn
                  icon
                  small
                  :loading="loadingBalance"
                  title="Обновить остаток"
                  @click.stop="getBalance"
                >
                  <v-icon small>mdi-reload</v-icon>
                </v-btn>
              </v-list-item-title>
            </v-list-item-content>
          </template>

          <v-list-item>
            <v-list-item-content>
              <div>{{ store.user_info.usershort }}</div>
              <div>{{ store.user_info.postname }}</div>
              <div>{{ store.user_info.prov_name }}</div>
              <div v-if="balance">
                Остаток:
                <span style="color: green">{{ balance }}</span>
                руб.
                <!-- <v-btn
                  icon
                  small
                  :loading="loadingBalance"
                  title="Обновить остаток"
                  @click="getBalance"
                >
                  <v-icon small>mdi-reload</v-icon>
                </v-btn> -->
              </div>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>
      </v-list>
    </template>
    <slot></slot>
  </v-navigation-drawer>
</template>

<script setup>
import { ref, computed } from "vue";

import { Account } from "@/api/common";
import { useStore } from "@/store";

const store = useStore();

defineProps({
  visible: {
    type: Boolean,
    default: null,
  },
});

const loadingBalance = ref(false);

const balance = computed(() =>
  store.balance != undefined ? store.balance : ""
);

function getBalance() {
  loadingBalance.value = true;
  Account.get_balance()
    .then((balance) => store.setBalance(balance?.balance))
    .finally(() => (loadingBalance.value = false));
}
</script>
